// components/Layout.js
import React from "react";
import { useLocation } from "react-router-dom";
import LeftSidebar from "../../LeftSidebar";
import RightSidebar from "../../RightSidebar";
import "./Layout.css"; // optional layout styling
import Header from "../../../headers/Header";
import Footer from "../../../footer/footer/Footer";
import MobileFooter from "../../../footer/MobileFooter";
import WhatsAppWidget from "../../../utils/WhatsAppWidget";

const Layout = ({ children, type }) => {
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  return (
    <>
      <Header />
      <div className="container-fluid main-layout mt-1">
        {type === "full-width" ? (
          <div>
            <main className="main-content">{children}</main>
          </div>
        ) : (
          <div className="row no-gutters">
            {/* <div className="col-12 col-lg-3">
              <LeftSidebar />
            </div> */}

            {/* <div className="col-12 col-lg-9"> */}
            <main className="main-content">{children}</main>
            {/* </div> */}

            {/* <div className="col-12 col-lg-2">
              <RightSidebar />
            </div> */}
          </div>
        )}
      </div>
      {isHomePage && <Footer />}
      <MobileFooter />
      {isHomePage && <WhatsAppWidget />}
    </>
  );
};

export default Layout;
